import moment from 'moment';
class GlobalFunctionSingle {
    constructor() {
        this.queue = {};
        this.numWord = [  '','one','two','three','four','five','six','seven','eight','nine','ten',
                        'eleven','twelve','thirteen','fourteen','fifteen','sixteen','seventeen','eighteen','nineteen','twenty',
                        'twenty-one','twenty-two','twenty-three','twenty-four','twenty-five','twenty-six','twenty-seven','twenty-eight','twenty-nine',
                        'thirty','thirty-one','thirty-two','thirty-three','thirty-four','thirty-five','thirty-six','thirty-seven','thirty-eight','thirty-nine',
                        'forty','forty-one','forty-two','forty-three','forty-four','forty-five','forty-six','forty-seven','forty-eight','forty-nine',
                        'fifty','fifty-one','fifty-two','fifty-three','fifty-four','fifty-five','fifty-six','fifty-seven','fifty-eight','fifty-nine']
    }

    getModuleWidth(columns, maxColumns) {
        /**
         * Based on the following:
         *  Whole window has a 5pt border, hence the -10 at the start
         *  This gives us 12 columns -> hence divide by 12
         *  Multiply by the nuumber of columns itself -> ie columns
         *  Take off 10pt for the spacing between each grid item
         */

         let width=0;
        if (window.outerWidth === 0) {
            // iOs devices
            width = window.innerWidth
        } else {
            width = window.outerWidth
        }
    
        return ((((width -10) / maxColumns) * columns) - 10);

    }

    getPaletteColour(configColour) {

        let headingColour = '';
        switch (configColour) {
            case 'success':
                headingColour = '#27aa74'
                break;
            case 'primary':
                headingColour = '#3f7cac'
                break;
            case 'warning':
                headingColour = '#f7bf3d'
                break;
            case 'danger':
                headingColour = '#ec0b43'
                break;
            case 'info':
                headingColour = '#4cc8e8'
                break;
        default:    
            headingColour = '#ffffff'
            
        }

        return headingColour;
    }

    getRGBPaletteColour(configColour) {

        let headingColour = '';
        switch (configColour) {
            case 'success':
                headingColour = '39,170,116'
                break;
            case 'primary':
                headingColour = '63,124,172'
                break;
            case 'warning':
                headingColour = '247,191,61'
                break;
            case 'danger':
                headingColour = '236,11,67'
                break;
            case 'info':
                headingColour = '76,200,232'
                break;
        default:    
            headingColour = '255,255,255'
            
        }

        return headingColour;
    }


    getPaletteContrastColour(configColour) {

        let headingColour = '';
        switch (configColour) {
            case 'success':
                headingColour = '#ffffff'
                break;
            case 'primary':
                headingColour = '#ffffff'
                break;
            case 'warning':
                headingColour = '#333333'
                break;
            case 'danger':
                headingColour = '#ffffff'
                break;
            case 'info':
                headingColour = '#ffffff'
                break;
        default:    
            headingColour = '#333333'
            
        }

        return headingColour;
    }


    getFontSize(text, width, height, ref) {

        if (width < 0 || height < 0) {
            // we can't allow negatives
            return(8);
        }

        // set the text in the box and loop until it is no wider than the box
        // starting size is the height of the box

//console.log('getFontSize',text, width, height)
        ref.innerHTML = text;
        let fontSize = height;
        ref.style.lineHeight = fontSize + "px";

        ref.style.fontSize = fontSize + "px";
        do {
            fontSize--;
            ref.style.fontSize = fontSize + "px";
            ref.style.lineHeight = fontSize + "px";
            //console.log('Fontsize of ', fontSize, ' is ', ref.clientWidth , ' pixels wide.')
        } while (ref.clientWidth > width)

        if (fontSize < 8) {
            // min size
            fontSize = 8;
        }


        ref.height = height;
        return Math.floor(fontSize);
    }

    getFontSizeVariableHeight(text, width, height, ref) {

        if (width < 0 || height < 0) {
            // we can't allow negatives
            return(8);
        }

        ref.width = width;
        ref.style.width = width + "px";

        // set the text in the box and loop until it is no wider than the box
        // starting size is the height of the box

//console.log('getFontSize',text, width, height)
        ref.innerHTML = text;
        let fontSize = height;
        ref.style.lineHeight = fontSize + "px";
    

        ref.style.fontSize = fontSize + "px";
        do {
            fontSize--;
            ref.style.fontSize = fontSize + "px";
            ref.style.lineHeight = fontSize + "px";

            //console.log('Fontsize of ', fontSize, ' widths ', ref.clientWidth , '  scroll ', ref.scrollWidth)
        } while (ref.clientHeight > height || ref.scrollWidth > ref.clientWidth )

        if (fontSize < 8) {
            // min size
            fontSize = 8;
        }

        ref.width = width;
        
        return Math.floor(fontSize);
    }

    getMultiLineFontSize(text, width,height,  ref) {
        ref.innerHTML = text;
        ref.style.height = height + "px";
        ref.style.width = width + "px";
        let fontSize = ref.clientHeight;
        ref.style.lineHeight = fontSize + "px";

        ref.style.fontSize = fontSize + "px";
        do {
            fontSize--;
            ref.style.fontSize = fontSize + "px";
            ref.style.lineHeight = fontSize + "px";
            //console.log('Fontsize of ', fontSize, ' is ', ref.clientWidth , ' pixels wide.')
        } while (ref.scrollHeight > ref.clientHeight)
       
        return Math.floor(fontSize);
    }

    getTextWidth(text, fontSize, ref) {

        ref.innerHTML = text;
        ref.style.fontSize = fontSize + "px";

        return ref.clientWidth;
    }

    //this.state.clockLocalOffset, this.props.parameters.config
    getAdjustedDate(clockLocalOffset, config) {
        /**
         * THIS WAS THE CODE ON 22/Jul/2019 
         * COnsidered buggy as we loose information as setMilliseconds requires data in rane 0-999
         * We really need an add milliseconds 
         *         var currentDate = new Date();
         *         // adjust the clock to server time 
         *         currentDate.setMilliseconds(currentDate.getMilliseconds() +  config.clockOffset - config.timeMasterClockOffset);
         *         currentDate.setSeconds(currentDate.getSeconds() + clockLocalOffset);
         */
       

        let ourAdjustedTime =   Date.now() +
                                config.clockOffset -
                                config.timeMasterClockOffset + // the clockOffset in the message is from the sender
                                (clockLocalOffset * 1000);
        let currentDate = new Date(ourAdjustedTime);
          
        return currentDate;
    }

    updateClock(clockLocalOffset, config) {
        // Create two variable with the names of the months and days in an array
        const monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ]; 
        const dayNames= ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]

        // Create a newDate() object
        let newDate = this.getAdjustedDate(clockLocalOffset, config);
      
        // Extract the current date from Date object
        newDate.setDate(newDate.getDate());
        // Output the day, date, month and year    
        let textDate = dayNames[newDate.getDay()] + ' ' + newDate.getDate() + ' ' + monthNames[newDate.getMonth()] + ' ' + newDate.getFullYear();
        textDate = moment(newDate).format('dddd') + ' ' + moment(newDate).format('Do') + ' ' + moment(newDate).format('MMMM') + ' ' + moment(newDate).format('YYYY');

        // Create a newDate() object and extract the seconds of the current time on the visitor's

        let currentDate = this.getAdjustedDate(clockLocalOffset, config);
       
        
        var seconds = currentDate.getSeconds();
        var minutes = currentDate.getMinutes();
        var hours = currentDate.getHours();
        //console.log('Post: ', seconds, currentDate.getMilliseconds());
        // Add a leading zero to seconds value
        let ctSeconds = ( seconds < 10 ? "0" : "" ) + seconds;

        // Add a leading zero to the minutes value
        let ctMinutes = ( minutes < 10 ? "0" : "" ) + minutes;

        // update the time in words
        var theHour = currentDate.getHours();
        var origHour = theHour;
        if (theHour > 12) {
            theHour = theHour -12;
        } 

       
        let timeInWords="";
        let fullTimeInWords="";
        switch (minutes){
            case 0:
                if (origHour === 0) {
                    timeInWords="Midnight"
                    fullTimeInWords=timeInWords
                } else if (origHour === 12) {
                    timeInWords="Midday"
                    fullTimeInWords=timeInWords
                } else {
                    timeInWords= theHour + " o'clock exactly"
                    fullTimeInWords = this.numWord[theHour] +  " o'clock exactly"
                }
                break;
            case 1:
                timeInWords = "1 minute past " + ( theHour === 0 ? "12" : theHour);
                fullTimeInWords = "one minute past " + this.numWord[(theHour === 0 ? "12" : theHour)]
                break;
            case 15:
                timeInWords = "quarter past " + ( theHour === 0 ? "12" : theHour);
                fullTimeInWords = "quarter past " + this.numWord[(theHour === 0 ? "12" : theHour)]
                break;
            case 30:
                timeInWords = "half past " + ( theHour === 0 ? "12" : theHour);
                fullTimeInWords = "half past " + this.numWord[(theHour === 0 ? "12" : theHour)]
                break;
            case 45:
                timeInWords =  "quarter to " + (theHour === 12 ? "1" : theHour + 1 );
                fullTimeInWords =  "quarter to "  + this.numWord[(theHour === 12 ? "1" : theHour + 1 )] 
                break;
            case 59:
                timeInWords = "1 minute to " + ( theHour === 12 ? "1" : theHour + 1 );
                fullTimeInWords =  "one minute to "  + this.numWord[( theHour === 12 ? "1" : theHour + 1 )] 
                break;
            default:
                if (minutes < 30) {
                    timeInWords = minutes + " minutes past " + ( theHour === 0 ? "12" : theHour);
                    fullTimeInWords = this.numWord[minutes] + " minutes past " + this.numWord[( theHour === 0 ? "12" : theHour)]
                } else {
                    // has to be more than 30
                    timeInWords = (60-minutes) + " minutes to " + ( theHour === 12 ? "1" : theHour + 1 )
                    fullTimeInWords = this.numWord[(60-minutes)] + " minutes to " + this.numWord[( theHour === 12 ? "1" : theHour + 1 )]
                }

        }


        let ctMeridian="";
        if (hours === 12 ) {
            ctMeridian = "pm";
        } else if (hours === 0 ) {
            ctMeridian = "am";
            hours = 12;
        } else if (hours < 13) {
            ctMeridian = "am";
        } else {
            ctMeridian = "pm";
            hours = hours - 12;
        }
        // Add a leading zero to the hours value
        let ctHours =  hours;
        let currentTime = {hours: ctHours, minutes: ctMinutes, seconds: ctSeconds, meridian: ctMeridian}
        //this.setState({currentTime: currentTime});



        //this.setState({textDate: textDate});

        return({currentTime: currentTime, 
                timeInWords: fullTimeInWords, 
                textDate: textDate,
                currentDate: currentDate })

    }
    

}
const GlobalFunction = new GlobalFunctionSingle();
Object.freeze(GlobalFunction);

export default GlobalFunction;
//module.exports = new GlobalFunction();